import React from "react";
import { Message } from "components/Atoms/Message";
import UserAccountCard from "../../components/UserAccountCard";

interface Props {
  users: server.dto.UserSmall[]
  onUserSelect: (user: server.dto.UserSmall) => void
  isLoadingUserId: number
  errors?: string[]
}

const ChooseUserPanelContent = (props: Props) => {
  return <>
    <h2>
      {RESX.Account.ChooseWhichAccount}
    </h2>

    {props.errors?.length > 0 && <Message type="error" className="margin-bottom">
      {props.errors.map(e => <div key={e}>{e}</div>)}
    </Message>}

    <div className="list-with-gaps card-layout">
      <div className="list-with-gaps-body">
        {props.users.map(user => <UserAccountCard
          onClick={() => { props.onUserSelect(user); }}
          key={user.userId}
          user={user}
          className="hoverable"
          isLoading={props.isLoadingUserId === user.userId}
        />)}
      </div>
    </div>
  </>;
};

export default ChooseUserPanelContent;